  import React from 'react'
import { graphql } from 'gatsby'
import { Container, Col, Row } from 'reactstrap'

import SiteDocumentations from '../../../components/SiteDocumentations'

import SEO from '../../../components/seo'

import HydroRain from './hydrorain.png'

class hydroRain extends React.Component {
  render() {
    const seoData = {
      title: "Documentation produits d'irrigation HydroRain",
      description: "Consultez notre documentation des produits d'irrigation HydroRain",
      coverImage: HydroRain,
      path: this.props.location.pathname,
      schemaOrg: ''
    }

    return (
      <div>
        <SEO seoData={seoData} />
        <Container>
          <Row style={{alignItems: "center", marginBottom: 10}}>
            <Col lg={2} md={2} xs={6}>
              <img src={HydroRain} alt="HydroRain"/>
            </Col>
            <Col lg={10} md={10} xs={12}><h1>Manuels d’instruction HydroRain</h1></Col>
          </Row>
          <SiteDocumentations {...this.props} />
        </Container>
      </div>
    )
  }
}

export default hydroRain

export const hydroRainDocumentationQuery = graphql`
  query HydroRainDocumentation {
    site {
      meta: siteMetadata {
        title
        description
        url: siteUrl
        author
      }
    }
    remark: allMarkdownRemark(
      filter: { frontmatter: { vendor: { eq: "HydroRain" } } }
    ) {
      documentations: edges {
        documentation: node {
          id
          html
          frontmatter {
            layout
            title
            path
            coverImage {
              childImageSharp {
                fluid(maxWidth: 400) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
    }
  }
`
